import { render, staticRenderFns } from "./AffiliatePrivacyOfficerForm.vue?vue&type=template&id=72cbb2fc&"
import script from "./AffiliatePrivacyOfficerForm.vue?vue&type=script&lang=js&"
export * from "./AffiliatePrivacyOfficerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AffiliatePrivacyOfficerForm.vue"
export default component.exports